import { Box, Typography } from '@mui/material';
import { getSeriesLabel } from './chart-tooltip-utils';
import { TooltipData } from './types';

type ChartTooltipMultiProps = {
  data: TooltipData;
};

/**
 * Multi-series tooltip shown when the cursor is not near a specific line.
 */
export function ChartTooltipMulti({ data }: ChartTooltipMultiProps) {
  return (
    <>
      <Typography
        variant="caption"
        sx={{ fontWeight: 'bold', marginBottom: '4px', display: 'block' }}
      >
        {data.timestamp}
      </Typography>
      {data.series.map((series, index) => {
        const label = getSeriesLabel(series.label);
        const color = typeof series.color === 'string' ? series.color : '#000';

        return (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '2px',
            }}
          >
            <Box
              sx={{
                width: '8px',
                height: '8px',
                backgroundColor: color,
                marginRight: '6px',
                borderRadius: '50%',
              }}
            />
            <Typography variant="caption" sx={{ flex: 1 }}>
              {label}:
            </Typography>
            <Typography variant="caption" sx={{ fontWeight: 'bold', marginLeft: '4px' }}>
              {series.value.toLocaleString()}
            </Typography>
          </Box>
        );
      })}
    </>
  );
}
